import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { PieChart } from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../../../providers/AppProvider';
import ReactEchart from '../../../../../components/common/ReactEchart';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    PieChart,
    CanvasRenderer,
    LegendComponent
]);

const getOptions = (data, getThemeColor) => {
    if (!getThemeColor || typeof getThemeColor !== 'function') {
        console.error("getThemeColor is not a function or is undefined");
        return {};
    }

    return {
        tooltip: {
            trigger: 'item',
            padding: [7, 10],
            backgroundColor: '#fff',
            borderColor: '#ccc',
            textStyle: { color: '#000' },
            borderWidth: 1,
            transitionDuration: 0,
            formatter: function (params) {
                return `<strong>${params.data.name}:</strong> ${params.percent}%`;
            }
        },
        legend: { show: false },
        series: [
            {
                name: 'Ubicaciones',
                type: 'pie',
                radius: ['100%', '67%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderWidth: 2,
                    borderColor: '#fff'
                },
                label: {
                    show: false,
                    formatter: '{b}: {d}%'
                },
                emphasis: {
                    scale: false
                },
                labelLine: { show: false },
                data: data.map(group => ({ value: group.visits, name: group.title, itemStyle: { color: group.color }, groupTitle: group.title, alertType: group.title }))
            }
        ]
    };
};

const EstadiasUbicacionesFrecChart = ({ data, onSelectAlertType }) => {
    const chartRef = useRef(null);
    const { getThemeColor } = useAppContext() || {};
    const totalVisitas = data.reduce((sum, group) => sum + parseInt(group.visits, 10), 0);

    const handleChartClick = (params) => {
        if (params.data && params.data.alertType) {
            onSelectAlertType(params.data.alertType); // 🔹 Llamar a la función al hacer click en un segmento
        }
    };

    return (
        <div className="position-relative py-2">
            <ReactEchart
                ref={chartRef}
                echarts={echarts}
                option={getOptions(data, getThemeColor)}
                style={{ height: '12.5rem' }}
                onEvents={{ click: handleChartClick }} // 🔹 Detectar clic en gráfico
            />
            <div className="position-absolute top-50 start-50 translate-middle text-center">
                <p className="fs-10 mb-0 text-400 font-sans-serif fw-medium">Total</p>
                <p className="fs-6 mb-0 font-sans-serif fw-medium mt-n2">{totalVisitas}</p>
            </div>
        </div>
    );
};

EstadiasUbicacionesFrecChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            visits: PropTypes.number.isRequired,
            hours: PropTypes.number.isRequired
        })
    ).isRequired,
    onSelectAlertType: PropTypes.func.isRequired // Función para manejar clic en pastel
};

export default EstadiasUbicacionesFrecChart;
